import { useSmartMutation, useSmartQuery } from "@shared/api/queries/hooks";
import { consumptionApi } from "./api";
import { AddHelpfullPayload } from "./types";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";

export const useUpdateTipsStatus = () => {
  return useSmartMutation(
    (payload: AddHelpfullPayload) =>
      consumptionApi.addHelpful(payload)
  );
};

export const useTipsData = (params: {
  remote_utility_id: string;
  utility_service: any;
  show_inactive: any;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.cx.usage.tipsData(params),
    () => consumptionApi.getTipsData(params)
  );
};

export const useConsumerConsumptionKpi = (params: {
  remote_utility_id: string;
  consumer_no: string;
}, options?: any) => {
  return useSmartQuery(
    ["mx", "consumerConsumptionKpi", params],
    () => consumptionApi.getConsumerConsumptionKpi(params),
    options
  );
};
